module.exports = __webpack_public_path__ + "img/C5.02985592.png";